type NotificationMessages = {
  [key: string]: {
    primary: string;
    secondary?: string;
  };
};

export const notificationMessages: NotificationMessages = {
  "org.statement.create": {
    primary: "is now available",
    secondary: "A statement has been created for {orgName}",
  },

  /** @todo - not implemented */
  "org.playlist.create": {
    primary: "is now available",
    secondary: "{playlistName} has been added to your org",
  },

  /** @todo - not implemented */
  "member.role.change": {
    primary: "role has changed",
    secondary: "From {roleOne} to {roleTwo}",
  },

  /** @todo - not implemented */
  "member.invite.accepted": {
    primary: "has joined your organization",
  },

  /** @todo - not implemented */
  "member.permissions.change": {
    primary: "permissions have been updated",
  },

  "orgUser.stem.task.completed": {
    primary: "stem(s) are ready to download",
  },

  "orgUser.stem.task.error": {
    primary: "stems have failed to process",
    secondary: "Please try again",
  },

  "orgUser.bulkDownload.completed": {
    primary: "download is ready",
    secondary: "Your files have been packaged and are ready to download",
  },

  "orgUser.bulkDownload.error": {
    primary: "download has failed to process",
    secondary: "Please try again",
  },

  "orgUser.inviteBatch.completed": {
    primary: "invitations have been sent",
    secondary: "{sent} sent. View them in the Invited tab",
  },

  "orgUser.inviteBatch.error": {
    primary: "invitations could not all be sent",
    secondary:
      "{sent} sent, {failed} failed. Resend the failed ones from the Invited tab",
  },
};
